// extracted by mini-css-extract-plugin
module.exports = {"content":"something-else-step_content__tstgV","error":"something-else-step_error__iEvd_"};